<!-- 左侧导航 -->
<template>
  <div class="nav">
    <div class="logo" @click="returnHome">
      <img :src="require('../../assets/' + $regional.iconPath)" />
    </div>
    <div class="menu-container scroll">
      <div
        v-for="(item, index) in menuItems"
        :key="index + item.value"
        :class="activeMenu === item.link ? 'menu active' : 'menu'"
        @click="changeMenu(item)"
      >
        <span
          class="colorful img"
          :style="{
            '-webkit-mask': `url(${item.src}) no-repeat`,
            mask: `url(${item.src}) no-repeat`,
            'background-color':
              activeMenu === item.link ? 'var(--theme-color)' : '#fff'
          }"
        ></span>
        <span>{{ item.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'

export default {
  props: [],

  components: {},

  data() {
    return {
      menuItems: [
        {
          name: '运营',
          link: '/admin/operate',
          src: require('../../assets/operate.svg'),
          value: 'AdminOperate'
        },
        {
          name: '应用',
          link: '/admin/apply',
          src: require('../../assets/apply.svg'),
          value: 'AdminApplyManage'
        },
        {
          name: '配置',
          link: '/admin/config',
          src: require('../../assets/config.svg'),
          value: 'AdminConfig'
        },
        {
          name: '人员管理',
          link: '/district-admin/people',
          src: require('../../assets/operate.svg'),
          value: 'DistrictPeople'
        },
        {
          name: '权限配置',
          link: '/district-admin/permission',
          src: require('../../assets/config.svg'),
          value: 'DistrictPermission'
        },
        {
          name: '应用中心',
          link: '/district-admin/apply',
          src: require('../../assets/apply.svg'),
          value: 'DistrictApply'
        },
        {
          name: '校务管理',
          link: '/school-admin/affair',
          src: require('../../assets/operate.svg'),
          value: 'SchoolAffair'
        },
        {
          name: '权限配置',
          link: '/school-admin/permission',
          src: require('../../assets/config.svg'),
          value: 'SchoolPermission'
        },
        {
          name: '权限配置',
          link: '/school-admin/permission',
          src: require('../../assets/config.svg'),
          value: 'CityPermissionStudentEval'
        },
        {
          name: '应用中心',
          link: '/school-admin/apply',
          src: require('../../assets/apply.svg'),
          value: 'SchoolApply'
        },
        {
          name: '首页',
          link: '/teacher-home',
          src: require('../../assets/home.svg'),
          value: 'TeacherHome'
        },
        {
          name: '综合评价',
          link: '/teacher-grade-judge',
          src: require('../../assets/judge.svg'),
          value: 'TeacherGradeJudge'
        },
        {
          name: '综合评价',
          link: '/teacher-class-judge',
          src: require('../../assets/judge.svg'),
          value: 'TeacherClassJudge'
        },
        {
          name: '评价档案',
          link: '/teacher-judge-file',
          src: require('../../assets/judge-file.svg'),
          value: 'TeacherJudgeFile'
        },
        {
          name: '个性记录',
          link: '/teacher-grade-persona-record',
          src: require('../../assets/persona.svg'),
          value: 'TeacherGradePersonaRecord'
        },
        {
          name: '个性记录',
          link: '/teacher-class-persona-record',
          src: require('../../assets/persona.svg'),
          value: 'TeacherClassPersonaRecord'
        },
        {
          name: '素质报告',
          link: '/teacher-grade-quality-report',
          src: require('../../assets/report.svg'),
          value: 'TeacherGradeQualityReport'
        },
        {
          name: '素质报告',
          link: '/teacher-class-quality-report',
          src: require('../../assets/report.svg'),
          value: 'TeacherClassQualityReport'
        },
        {
          name: '首页',
          link: '/student-home',
          src: require('../../assets/home.svg'),
          value: 'StudentHome'
        },
        {
          name: '综合评价',
          link: '/student-judge-module',
          src: require('../../assets/judge.svg'),
          value: 'StudentJudgeModule'
        },
        {
          name: '素质报告',
          link: '/student-report-module',
          src: require('../../assets/report.svg'),
          value: 'StudentReportModule'
        },
        {
          name: '个性记录',
          link: '/student-persona-record',
          src: require('../../assets/persona.svg'),
          value: 'StudentPersonaRecord'
        },
        {
          name: '体质健康',
          link: '/student-physical-check',
          src: require('../../assets/health.svg'),
          value: 'StudentPhysicalCheck'
        },
        // {
        //   name: '首页',
        //   link: '/district-home',
        //   src: require('../../assets/home.svg'),
        //   value: 'DistrictHome'
        // },
        // {
        //   name: '综合评价',
        //   link: '/district-judge',
        //   src: require('../../assets/judge.svg'),
        //   value: 'DistrictJudge'
        // },
        {
          name: '首页',
          link: '/district-home',
          src: require('../../assets/home.svg'),
          value: 'DistrictHome'
        },
        // {
        //   name: '综合评价',
        //   link: '/district-home',
        //   src: require('../../assets/judge.svg'),
        //   value: 'DistrictHome'
        // },
        {
          name: '评价进度',
          link: '/judge-status',
          src: require('../../assets/judge.svg'),
          value: 'DistrictJudgeStatus'
        },
        {
          name: '素质报告',
          link: '/district-quality-report',
          src: require('../../assets/report.svg'),
          value: 'DistrictQualityReport'
        }
      ],
      activeMenu: '',
      cloneMenu: [],
      // 教师首页为非路由跳转页面切换，刷新及后退逻辑特殊处理
      specialPaths: ['teacher-home', 'student-home', 'district-judge']
    }
  },

  watch: {
    $route(to, from) {
      let pathArr = to.path.split('/')
      if (this.specialPaths.includes(pathArr[1])) {
        this.activeMenu = '/' + pathArr[1]
      } else {
        const activeMenu =
          pathArr.length > 2
            ? '/' + pathArr[1] + '/' + pathArr[2]
            : '/' + pathArr[1]
        this.activeMenu = activeMenu
      }
    }
  },

  computed: {
    ...mapState(['user'])
  },

  mounted() {
    this.initMenu()
  },

  methods: {
    initMenu() {
      // 获取菜单
      let menus = null
      let userInfo = this.$store.state.user
      if (!userInfo) {
        menus = this.$store.getters['user/getMenu']()
      } else {
        menus = userInfo.menus
      }
      // level 层级
      // type 类型 1菜单
      let levelOne = _.filter(menus, { level: 1, type: 1 })
      let menuItems = _.cloneDeep(this.menuItems)
      this.cloneMenu = menuItems
      let temp = []
      for (let index = 0; index < levelOne.length; index++) {
        let element = levelOne[index]
        for (let innerIndex = 0; innerIndex < menuItems.length; innerIndex++) {
          let innerElement = menuItems[innerIndex]
          if (innerElement.value === element.name) {
            this.$set(innerElement, 'id', element.id)
            temp.push(innerElement)
          }
        }
      }
      // 去重重复name的菜单项
      const uniqMenu = _.uniqWith(temp, function(arrVal, othVal) {
        return arrVal.name === othVal.name
      })
      this.menuItems = uniqMenu
      let pathArr = this.$route.path.split('/')
      if (this.specialPaths.includes(pathArr[1])) {
        this.activeMenu = '/' + pathArr[1]
      } else {
        const activeMenu =
          pathArr.length > 2
            ? '/' + pathArr[1] + '/' + pathArr[2]
            : '/' + pathArr[1]
        this.activeMenu = activeMenu
      }
      let target = _.filter(menuItems, { link: this.activeMenu })
      let nav = JSON.parse(localStorage.getItem('firstNav'))
      if (!nav) {
        this.$store.commit('user/firstNav', target[0])
        localStorage.setItem('firstNav', JSON.stringify(target[0]))
      }
    },

    returnHome() {},

    changeMenu(menu) {
      this.$bus.emit('menuClick', menu)
      this.activeMenu = menu.link
      let activeMenu = _.filter(this.menuItems, { link: this.activeMenu })[0]
      this.$store.commit('user/firstNav', activeMenu)
      localStorage.setItem('firstNav', JSON.stringify(activeMenu))
      let menus = null
      let userInfo = this.$store.state.user
      if (!userInfo) {
        menus = this.$store.getters['user/getMenu']()
      } else {
        menus = userInfo.menus
      }
      let levelOne = _.filter(menus, { level: 1, type: 1 })
      let levelTwo = _.filter(menus, { level: 2, type: 1 })
      let parentIds = _.uniq(_.map(levelTwo, 'parentId'))
      let levelOneIds = _.uniq(_.map(levelOne, 'id'))
      // 找出二级菜单中parentId不为第一级菜单id的项
      let difference = parentIds
        .concat(levelOneIds)
        .filter(v => !parentIds.includes(v) || !levelOneIds.includes(v))
      if (difference.includes(menu.id)) {
        this.$router.push({ name: menu.value })
      } else {
        let secondMenu = _.filter(levelTwo, { parentId: menu.id })[0]
        this.$router.push({ name: secondMenu.name })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.nav {
  float: left;
  text-align: center;
  height: 100%;
  width: 60px;
  background-color: var(--theme-color);
  cursor: pointer;
}
.logo {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  width: 60px;
  margin-bottom: 40px;
}
.menu-container {
  height: calc(100% - 100px);
  overflow-y: scroll;
}
.menu {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60px;
  width: 60px;
  margin-bottom: 20px;
  cursor: pointer;
  .img {
    display: inline-block;
    width: 20px;
    height: 20px;
    -webkit-mask-size: 100% 100%;
    mask-size: 100% 100%;
  }
}
.active {
  background-color: #fff;
}
.menu span {
  font-size: 14px;
  color: #ffffff;
  padding-top: 5px;
}
.active span {
  font-size: 14px;
  color: var(--theme-color);
  padding-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/NavBar.vue